import _isEmpty from 'lodash/isEmpty';

import pageApi from './api';
import * as types from './actionTypes';
import { BLOG_PAGE_PATH_PART } from './constants';

function fetchPageStart(alias) {
  return {
    type: types.FETCH_REQUEST,
    payload: { alias },
  };
}

function fetchPageDone(alias, data) {
  return {
    type: types.FETCH_SUCCESS,
    payload: { alias, data },
  };
}

function fetchPageFail(alias, error) {
  return {
    type: types.FETCH_FAILURE,
    payload: { alias, error },
  };
}

export const fetchPage = alias => {
  return dispatch => {
    dispatch(fetchPageStart(alias));

    return pageApi
      .getPage(alias)
      .then(data => dispatch(fetchPageDone(alias, data)))
      .catch(({ error }) => dispatch(fetchPageFail(alias, error)));
  };
};

export const fetchPageIsNeeded = alias => {
  return (dispatch, getState) => {
    if (_isEmpty(getState().page.list[alias])) {
      return dispatch(fetchPage(alias));
    }

    return null;
  };
};

//

function fetchCompositeDetailStart(alias) {
  return {
    type: types.FETCH_COMPOSITE_DETAIL_REQUEST,
    payload: { alias },
  };
}

function fetchCompositeDetailDone(alias, data) {
  return {
    type: types.FETCH_COMPOSITE_DETAIL_SUCCESS,
    payload: { alias, data },
  };
}

function fetchCompositeDetailFail(alias, error) {
  return {
    type: types.FETCH_COMPOSITE_DETAIL_FAILURE,
    payload: { alias, error },
  };
}

export const fetchCompositeDetail = alias => {
  return dispatch => {
    dispatch(fetchCompositeDetailStart(alias));

    return pageApi
      .getCompositeDetail(alias)
      .then(data => dispatch(fetchCompositeDetailDone(alias, data)))
      .catch(({ error }) => dispatch(fetchCompositeDetailFail(alias, error)));
  };
};

export const fetchCompositeDetailIsNeeded = alias => {
  return (dispatch, getState) => {
    if (_isEmpty(getState().page.list[alias])) {
      return dispatch(fetchCompositeDetail(alias));
    }

    return null;
  };
};

//

function fetchCompositeListStart() {
  return {
    type: types.FETCH_COMPOSITE_LIST_REQUEST,
  };
}

function fetchCompositeListDone(data) {
  return {
    type: types.FETCH_COMPOSITE_LIST_SUCCESS,
    payload: { data },
  };
}

function fetchCompositeListFail(error) {
  return {
    type: types.FETCH_COMPOSITE_LIST_FAILURE,
    payload: { error },
  };
}

export const fetchCompositeList = () => {
  return dispatch => {
    dispatch(fetchCompositeListStart());

    return pageApi
      .getCompositeList()
      .then(data => dispatch(fetchCompositeListDone(data)))
      .catch(({ error }) => dispatch(fetchCompositeListFail(error)));
  };
};

export const fetchCompositeListIsNeeded = () => {
  return (dispatch, getState) => {
    if (_isEmpty(getState().page.compositeList)) {
      return dispatch(fetchCompositeList());
    }

    return null;
  };
};

export const initializeBlogPagesIfNeeded = () => async (dispatch, getState) => {
  const isBlogPagesLoaded = getState().page.blog.isInitialised;

  if (!isBlogPagesLoaded) {
    const allPages = getState().city?.userCity?.pages ?? [];

    const blogPages = allPages.filter(page => page.startsWith(BLOG_PAGE_PATH_PART));

    const blogsPagesRowData = await Promise.all(blogPages.map(page => dispatch(fetchPage(page))));

    const blogsPagesPreparedData = blogsPagesRowData.map(({ payload }) => {
      const htmlString = payload?.data?.body ?? '';
      let image = null;
      let text = null;

      if (typeof document !== 'undefined') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        const firstImg = tempDiv.querySelector('img');
        if (firstImg) {
          image = firstImg.getAttribute('src');
        }
      }
      if (typeof document !== 'undefined') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        const paragraphs = tempDiv.querySelectorAll('p');
        for (const p of paragraphs) {
          const content = p.textContent.trim();
          if (content.length > 0) {
            text = content;
            break;
          }
        }

        if (text === null) {
          text = '';
        }
      }

      return {
        url: payload?.alias,
        title: payload?.data?.title,
        body: htmlString,
        image,
        text,
      };
    });

    await dispatch({ type: types.SEPARATE_BLOG_PAGES, payload: blogsPagesPreparedData });
  }
};
